import { ActionFeedbackDialog } from '../../../../../../components/ActionFeedbackDialog';

type ConfirmDeleteModalProps = {
  open: boolean;
  title: string;
  message: string;
  onCancel: () => void;
  onConfirm: () => void;
};

export const ConfirmDeleteModal = ({ open, title, message, onCancel, onConfirm }: ConfirmDeleteModalProps) => {
  return (
    <ActionFeedbackDialog
      open={open}
      type="warning"
      title={title}
      onClose={onCancel}
      description={
        <p>
          {message}
          <br />
          <strong> Você confirma essa ação?</strong>
        </p>
      }
      secondaryAction={{ label: 'Cancelar', onClick: onCancel }}
      primaryAction={{
        label: 'Excluir',
        onClick: () => {
          onConfirm();
          onCancel();
        },
      }}
    />
  );
};
